import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface WoPenaltyRow {
  id: string;
  team_id: string;
  league_id: string;
  forgiven: boolean;
  created_at: string;
  [key: string]: unknown;
}

export function useTeamPenalties(teamId: string | undefined, leagueId: string | undefined) {
  const { data: penalties = [], isLoading } = useQuery({
    queryKey: ["team-wo-penalties", teamId, leagueId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("league_wo_penalties" as any)
        .select("*")
        .eq("team_id", teamId!)
        .eq("league_id", leagueId!);
      if (error) throw error;
      return (data ?? []) as WoPenaltyRow[];
    },
    enabled: !!teamId && !!leagueId,
  });

  const activeCount = penalties.filter((p) => !p.forgiven).length;
  const forgivenCount = penalties.filter((p) => p.forgiven).length;

  return {
    penalties,
    activeCount,
    forgivenCount,
    isLoading,
    // Default threshold is 2 if not configured
    isBlocked: (maxWo: number = 2) => activeCount >= maxWo,
  };
}
